<template>
  <div class="comp-xl-color-picker">
    <jw-popover trigger="click" position="bl" v-model:popup-visible="popVisible" :blur-to-close="true" :popup-container="props.popupContainer">
      <!-- 新建图表选择字色的地方 -->
      <div v-if="props.type == 1" class="check_theme_Color" @click="checkPopVisible">
        <icon-font-colors
          style="font-size: 20px"
          :style="{
            color: checkColor.background ? checkColor.background : ''
          }"
        />
        <icon-caret-down />
      </div>
      <!-- 流程阶段添加节点颜色 -->
      <div v-else-if="props.type == 2">
        <icon-down style="color: var(--color-text-2)" size="12" />
      </div>
      <!-- 新增字段的地方选择字段背景 -->
      <div
        v-else
        class="checkColor"
        @click="checkPopVisible"
        :style="{
          backgroundColor: checkColor.background ? checkColor.background : '',
          color: checkColor.color ? checkColor.color : ''
        }"
      >
        <icon-caret-down />
      </div>
      <template #content>
        <div class="empty-item" @click="clearColor"></div>
        <div class="colorPicker-box">
          <div v-for="(item, index) in colorList" :key="index" class="colorPicker-item" :class="{ active: item.color === checkColor?.color && item.background === checkColor.background }" @click="clickColor(item)">
            <div
              class="swatches-color"
              :style="{
                backgroundColor: item.background,
                color: item.color
              }"
            ></div>
          </div>
        </div>
      </template>
    </jw-popover>
  </div>
</template>

<script setup>
import { ref, watch, reactive } from 'vue';
import colorResult from '@/utils/color.js';
const props = defineProps({
  element: {
    type: Object
  },
  type: {
    //默认是新建字段时，1：图标选择字色来源
    type: String,
    default: () => ''
  },
  popupContainer: {
    //挂载容器
    type: String,
    default: () => 'body'
  }
});

// console.log('@@@@@', props);
const emits = defineEmits(['cb']);
const popVisible = ref(false);
const colorList = ref(colorResult);
const checkColor = reactive({
  background: props.element.background ?? '',
  color: props.element.color ?? ''
});

function checkPopVisible() {
  popVisible.value = !popVisible.value;
}

function clickColor(item) {
  checkColor.background = item.background;
  checkColor.color = item.color;
  popVisible.value = false;
  const cbParams = {
    id: props.element.id,
    value: props.element.value,
    style: item
  };
  emits('cb', cbParams);
}

function clearColor() {
  checkColor.background = '';
  checkColor.color = '';
  popVisible.value = false;
  const cbParams = {
    id: props.element.id,
    value: props.element.value,
    style: checkColor
  };
  emits('cb', cbParams);
}
watch(
  () => props.element,
  (v) => {
    checkColor.background = v.background;
    checkColor.color = v.color;
  }
);
defineExpose({
  checkPopVisible
});
</script>
<style scoped lang="less">
@import './xl-color-picker.less';
</style>
